var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-container"},[_vm._v(" here will be newsletter stuff "),_c('span',[_vm._v("Newsletter: "+_vm._s(_vm.user.newsletter))])])}
var staticRenderFns = []

export { render, staticRenderFns }